import React, { useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {
  Box,
  Button,
  IconButton,
  Input,
  Select,
  Slide,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography
} from '@mui/material';
import {
  AddCircleOutlined,
  CancelOutlined,
  Check
} from '@mui/icons-material';

import styles from '../../../style';

const names = [
  'E78.2 mixed hyperlipidemia',
  'F09 organic brain syndrome',
  'F41.9 anxiety disorder, unspecified',
  'G06.0 brain abscess',
  'G25.3 nocturnal myoclonus',
  'G47.00 insomnia, unspecified',
  'G89.29 other chronic pain',
  'I10 hypertension',
  'I10 essential (primary) hypertension',
  'I50.9 congestive heart failure',
  'Icd005 test created by vaisakh',
  'J06.9 acute upper respiratory infection, unspecified',
  'J30.9 allergic rhinitis, unspecified',
  'A04.7 c. Diff colitis',
  'A08.11 norovirus',
  'A09 infectious gastroenteritis and colitis, unspecified',
  'A15.0 tuberculosis of lung',
  'A41.9 sepsis',
  'A64 unspecified sexually transmitted disease',
  'B349 viral infection, unspecified',
  'D259 leiomyoma',
  'D64.9 anemia, unspecified',
  'E03.9 hypothyroidism, unspecified',
  'E10.9 type 1 diabetes mellitus without complications',
  'E11.8 type 2 diabetes mellitus with unspecified complications',
  'E11.9 type 2 diabetes mellitus without complications',
  'E29.1 testicular hypofunction',
  'E55.9 vitamin d deficiency, unspecified',
  'E66.9 obesity, unspecified'
];

const System = () => {
  const [userCode, setUserCode] = useState([]);
  const [isEdit, setIsEdit] = useState(false);

  const handleChangeMultiple = event => {
    const values = Array.from(
      event.target.selectedOptions,
      option => option.value
    );

    setUserCode(values);
  };

  const handleToggleEdit = () => {
    setIsEdit(prev => !prev);
  };

  return (
    <Box sx={styles.templateWrap}>
      <Box sx={styles.templateHead}>
        <Typography>
          System CPT &amp; Descriptions
        </Typography>
      </Box>

      <Box sx={styles.templateBody}>
        <Box sx={{ maxHeight: 'calc(100vh - 298px)' }}>
          <Table
            sx={{
              ...styles.templateTable,
              overflow: 'hidden'
            }}
          >
            <TableHead>
              <TableRow>
                <TableCell sx={{ width: '100%' }}>
                  <TextField
                    fullWidth
                    placeholder="Search system codes and descriptions"
                    size="small"
                    sx={styles.textBox}
                    variant="outlined"
                  />
                </TableCell>

                <TableCell
                  align="center"
                  sx={{ whiteSpace: 'nowrap' }}
                >
                  <Button
                    color="primary"
                    onClick={handleToggleEdit}
                    size="small"
                    sx={
                      isEdit
                        ? {
                            ...styles.addButton,
                            backgroundColor: '#B9B9B9',
                            '&:hover': {
                              backgroundColor: '#A8A8A8'
                            }
                          }
                        : styles.addButton
                    }
                    variant="contained"
                  >
                    {isEdit ? (
                      <CancelOutlined />
                    ) : (
                      <AddCircleOutlined />
                    )}
                  </Button>
                </TableCell>
              </TableRow>
            </TableHead>

            {isEdit && (
              <Slide
                direction="down"
                in
                mountOnEnter
                timeout={200}
                unmountOnExit
              >
                <TableHead>
                  <TableRow>
                    <TableCell
                      sx={{
                        width: '100%',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <TextField
                        placeholder="Input Code"
                        size="small"
                        sx={{
                          ...styles.textBox,
                          width: 80
                        }}
                        variant="outlined"
                      />

                      <TextField
                        placeholder="Input Description"
                        size="small"
                        sx={{
                          ...styles.textBox,
                          ml: '5px',
                          width: 'calc(100% - 85px)'
                        }}
                        variant="outlined"
                      />
                    </TableCell>

                    <TableCell
                      align="center"
                      sx={{ whiteSpace: 'nowrap' }}
                    >
                      <IconButton
                        color="primary"
                        onClick={handleToggleEdit}
                        size="small"
                        sx={{
                          color: '#03A484',
                          ml: '-15px'
                        }}
                      >
                        <Check />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Slide>
            )}

            <TableBody>
              <TableRow>
                <TableCell
                  colSpan={2}
                  sx={{
                    borderColor: 'transparent',
                    height: 'calc(100vh - 400px)',
                    p: 0
                  }}
                >
                  <PerfectScrollbar
                    style={{
                      height: 'calc(100vh - 400px)'
                    }}
                  >
                    <Select
                      input={<Input disableUnderline />}
                      inputProps={{ size: 29 }}
                      multiple
                      native
                      onChange={handleChangeMultiple}
                      sx={styles.multiSel}
                      value={userCode}
                      variant="standard"
                    >
                      {names.map(name => (
                        <option
                          key={name}
                          value={name}
                        >
                          {name}
                        </option>
                      ))}
                    </Select>
                  </PerfectScrollbar>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Box>
      </Box>
    </Box>
  );
};

export default System;